var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"outer-pad opening-panel no-pad-bottom padding-top"},[_c('div',{class:{'info-panel': _vm.infoPanel, 'opening-panel-inner': true}},[_vm._t("title"),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }